import CubeLockIcon from 'public/icons/locker-selection-icons/cube-outline.svg';
import LocationIcon from 'public/icons/locker-selection-icons/location-outline.svg';
import PersonIcon from 'public/icons/locker-selection-icons/person-circle-outline.svg';
import PriceIcon from 'public/icons/locker-selection-icons/pricetag-outline.svg';
import WalletIcon from 'public/icons/locker-selection-icons/wallet-outline.svg';
import { useTranslation } from 'react-i18next';

import { ShippingExplanationModal } from './ShippingExplanationModal/ShippingExplanationModal';

const PAXI_URL = 'https://map.paxi.co.za/';

export const PaxiLockerModal = () => {
  const { t } = useTranslation();

  const icons = [
    <LocationIcon key="location" />,
    <PriceIcon key="price" />,
    <CubeLockIcon key="lock" />,
    <PersonIcon key="person" />,
    <WalletIcon key="time" />,
  ];

  const content = {
    title: t('components.order-block.paxi-locker-modal.title'),
    bullets: (
      (t('components.order-block.paxi-locker-modal.explanation.bullets', {
        returnObjects: true,
        paxiUrl: PAXI_URL,
      }) || []) as string[][]
    ).map(([title, text], index) => ({
      icon: icons[index],
      title,
      text,
    })),
    cta: t('components.order-block.paxi-locker-modal.ok'),
  };

  return <ShippingExplanationModal content={content} />;
};
